/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/fr_FR';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Accéder à l’éditeur Pretty HTML"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Vérificateur d''accessibilité"
  },
  "action_to_take_b626a99a": {
    "message": "Mesures à prendre :"
  },
  "add_8523c19b": {
    "message": "Ajouter"
  },
  "add_a_caption_2a915239": {
    "message": "Ajoutez une légende"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Ajouter texte alt pour l''image"
  },
  "add_another_f4e50d57": {
    "message": "Ajouter un autre"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Ajouter des sous-titres/CC"
  },
  "add_image_60b2de07": {
    "message": "Ajouter une image"
  },
  "add_one_9e34a6f8": {
    "message": "Ajouter une page!"
  },
  "additional_considerations_f3801683": {
    "message": "Considérations supplémentaires"
  },
  "address_applied_64269b0b": {
    "message": "Adresse appliquée"
  },
  "address_removed_fcb496e0": {
    "message": "Adresse supprimée"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Liens adjacents avec la même URL devrait être une liaison unique."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Aligner"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Alignement et listes"
  },
  "all_4321c3a1": {
    "message": "Tout"
  },
  "all_apps_a50dea49": {
    "message": "Toutes les applications"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Autoriser le téléchargement de support"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Autoriser le téléchargement de transcription"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "Ordre alphabétique"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Le texte alt ne peut pas être constitué de plus de 120 caractères."
  },
  "alt_text_611fb322": {
    "message": "Texte alternatif"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduit)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Une erreur s''est produite pendant la lecture du fichier"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Une erreur s''est produite en faisant une demande de réseau"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Une erreur s''est produite pendant le téléversement de votre support."
  },
  "and_7fcc2911": {
    "message": "et"
  },
  "angle_c5b4ec50": {
    "message": "Angle"
  },
  "announcement_fb4cb645": {
    "message": "Annonce"
  },
  "announcement_list_da155734": {
    "message": "Liste des annonces"
  },
  "announcements_a4b8ed4a": {
    "message": "Annonces"
  },
  "apply_781a2546": {
    "message": "Appliquer"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Appliquer les modifications à toutes les instances de cette icône « Créateur d’icône » dans le cours"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Approche de la limite"
  },
  "approximately_e7965800": {
    "message": "Environ"
  },
  "apps_54d24a47": {
    "message": "Applications"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Voulez-vous vraiment annuler? Les changements effectués ne seront peut-être pas enregistrés."
  },
  "arrows_464a3e54": {
    "message": "Flèches"
  },
  "art_icon_8e1daad": {
    "message": "Icône d’art"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Les proportions seront préservées"
  },
  "assignment_976578a8": {
    "message": "Travail"
  },
  "assignments_1e02582c": {
    "message": "Travaux"
  },
  "asterisk_82255584": {
    "message": "Astérisque"
  },
  "attributes_963ba262": {
    "message": "Attributs"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Enregistrement audio et vidéo non pris en charge; veuillez utiliser un autre navigateur."
  },
  "audio_options_feb58e2c": {
    "message": "Options audio"
  },
  "audio_options_tray_33a90711": {
    "message": "Plateau des Options Audio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Lecteur audio pour { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Le contenu enregistré automatiquement existe. Désirez-vous charger le contenu enregistré automatiquement à la place?"
  },
  "available_folders_694d0436": {
    "message": "Dossiers disponibles"
  },
  "background_1bc88842": {
    "message": "Fond"
  },
  "backslash_b2d5442d": {
    "message": "Barre oblique inversée"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Basique"
  },
  "because_501841b": {
    "message": "Parce que"
  },
  "below_81d4dceb": {
    "message": "Au dessous de"
  },
  "beta_cb5f307e": {
    "message": "Bêta"
  },
  "big_circle_16b2e604": {
    "message": "Grand Cercle"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Coefficient binomial"
  },
  "black_4cb01371": {
    "message": "Noir"
  },
  "blue_daf8fea9": {
    "message": "Bleu"
  },
  "bold_applied_42d547b7": {
    "message": "Caractères gras appliqués"
  },
  "bold_removed_da474a5c": {
    "message": "Caractères gras supprimés"
  },
  "border_5b08b06d": {
    "message": "Frontière"
  },
  "bottom_15a2a9be": {
    "message": "Inférieur"
  },
  "bottom_third_5f5fec1d": {
    "message": "Troisième inférieure"
  },
  "bowtie_5f9629e4": {
    "message": "Noeud papillon"
  },
  "brick_f2656265": {
    "message": "Brique"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Annuler"
  },
  "cap_product_3a5265a6": {
    "message": "Produit Maj"
  },
  "caption_manager_aae0906f": {
    "message": "Gestionnaire des légendes"
  },
  "center_align_e68d9997": {
    "message": "Aligner au centre"
  },
  "centered_dot_64d5e378": {
    "message": "Point centré"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Points centrés horizontaux"
  },
  "change_alt_text_92654906": {
    "message": "Modifier le texte alternatif (texte Alt)"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Modifier la balise d’entête au paragraphe"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Modifier uniquement le niveau de ce titre"
  },
  "change_text_color_1aecb912": {
    "message": "Modifier la couleur du texte"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "Les modifications s''appliqueront après l''enregistrement de cette page."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Les changements effectués ne seront peut-être pas enregistrés."
  },
  "characters_9d897d1c": {
    "message": "Personnages"
  },
  "characters_no_spaces_485e5367": {
    "message": "Caractères (pas d’espaces)"
  },
  "check_accessibility_3c78211c": {
    "message": "Vérifier l''accessibilité"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Vérification des problèmes d''accessibilité"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Choisir le fichier de légende"
  },
  "choose_usage_rights_33683854": {
    "message": "Choisir les droits d’utilisation..."
  },
  "circle_484abe63": {
    "message": "Cercle"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "liste ronde non triée"
  },
  "clear_2084585f": {
    "message": "Effacer"
  },
  "clear_image_3213fe62": {
    "message": "Effacer l’image"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Cliquez ou cliquez en maintenant enfoncé la touche majuscule (MAJ) pour l’éditeur HTML."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Cliquer pour incorporer { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Cliquer pour masquer les Aperçus"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Cliquez pour insérer un lien dans l’éditeur."
  },
  "click_to_show_preview_faa27051": {
    "message": "Cliquer pour afficher les Aperçus"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Fermer un menu ou une boîte de dialogue. Vous renvoie également à la zone d''édition"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Fermer le vérificateur d''accessibilité"
  },
  "close_d634289d": {
    "message": "Fermer"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Fermer la fenêtre modale des raccourcis clavier"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Le fichier de légendes doit être inférieur à { maxKb } Ko"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Légendes/sous-titres"
  },
  "clubs_suit_c1ffedff": {
    "message": "Trèfle (combinaison)"
  },
  "collab_575ac7bc": {
    "message": "Collaboration"
  },
  "collaborations_5c56c15f": {
    "message": "Collaborations"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Réduire pour masquer { types }"
  },
  "color_a363e1b0": {
    "message": "Couleur"
  },
  "color_contrast_4c418add": {
    "message": "Contraste des couleurs"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Rapport de contraste des couleurs"
  },
  "color_picker_6b359edf": {
    "message": "Sélecteur de couleur"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Sélecteur de couleur ({ colorName } sélectionné)"
  },
  "color_popup_af39810f": {
    "message": "Fenêtre contextuelle de couleur"
  },
  "column_e1ae5c64": {
    "message": "Colonne"
  },
  "column_group_1c062368": {
    "message": "Groupe de colonnes"
  },
  "complex_numbers_a543d004": {
    "message": "Nombres complexes"
  },
  "computer_1d7dfa6f": {
    "message": "Ordinateur"
  },
  "congruent_5a244acd": {
    "message": "Congruent"
  },
  "contains_311f37b7": {
    "message": "Contient"
  },
  "content_1440204b": {
    "message": "Contenu"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Le contenu de l’éditeur sera modifié. Appuyez sur Annuler pour conserver le contenu original."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Contenu est toujours en cours de téléversement, si vous continuez, l''image ne sera pas correctement intégrée."
  },
  "content_subtype_5ce35e88": {
    "message": "Sous-type de contenu"
  },
  "content_type_2cf90d95": {
    "message": "Type de contenu"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Continuer vers le contenu de YouTube"
  },
  "coproduct_e7838082": {
    "message": "Coproduit"
  },
  "copyright_holder_66ee111": {
    "message": "Détenteur des droits d’auteur :"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Impossible d’insérer le contenu : Les éléments de type « { itemType } » ne sont actuellement pas pris en charge dans Canvas."
  },
  "count_40eced3b": {
    "message": "Nombre"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 mot}\n    one {1 mot}\n  other {# mots}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# élément chargé}\n  other {# éléments chargés}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Documents du cours"
  },
  "course_files_62deb8f8": {
    "message": "Fichiers du cours"
  },
  "course_files_a31f97fc": {
    "message": "Fichiers du cours"
  },
  "course_images_f8511d04": {
    "message": "Images du cours"
  },
  "course_link_b369426": {
    "message": "Lien vers le cours"
  },
  "course_links_b56959b9": {
    "message": "Liens du cours"
  },
  "course_media_ec759ad": {
    "message": "Support média du cours"
  },
  "course_navigation_dd035109": {
    "message": "Navigation du cours"
  },
  "create_icon_110d6463": {
    "message": "Créer une icône"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Créer icône de Créateur d’icône"
  },
  "creative_commons_license_725584ae": {
    "message": "Licence Creative Commons :"
  },
  "crop_image_41bf940c": {
    "message": "Recadrer l’image"
  },
  "crop_image_807ebb08": {
    "message": "Recadrer l’image"
  },
  "cup_product_14174434": {
    "message": "Produit (UPC)"
  },
  "current_image_f16c249c": {
    "message": "Image actuelle"
  },
  "current_link_945a47ee": {
    "message": "Lien actuel"
  },
  "current_volume_level_c55ab825": {
    "message": "Niveau de volume actuel"
  },
  "custom_6979cd81": {
    "message": "Personnalisé"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Poignard"
  },
  "date_added_ed5ad465": {
    "message": "Date ajoutée"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Icône décorative"
  },
  "decorative_image_fde98579": {
    "message": "Image décorative"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "{ TYPE_UPPER } décorative"
  },
  "decrease_indent_d9cf469d": {
    "message": "Diminuer le retrait"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Diminuer la zone de contenu enrichi"
  },
  "deep_purple_bb3e2907": {
    "message": "Violet foncé"
  },
  "default_9db103d": {
    "message": "Par défaut"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "liste non triée à puces par défaut"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "liste triée numériquement par défaut"
  },
  "definite_integral_fe7ffed1": {
    "message": "Intégrale définie"
  },
  "degree_symbol_4a823d5f": {
    "message": "Symbole de degré"
  },
  "delimiters_4db4840d": {
    "message": "Délimiteurs"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Décrire l’icône)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Décrire { TYPE })"
  },
  "description_436c48d7": {
    "message": "Description"
  },
  "details_98a31b68": {
    "message": "Détails"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Points diagonaux"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Carreaux (combinaison)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Type de dimension"
  },
  "directionality_26ae9e08": {
    "message": "Directionnalité"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Éditer directement LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Désactiver l’aperçu"
  },
  "discussion_6719c51d": {
    "message": "Discussion"
  },
  "discussions_a5f96392": {
    "message": "Discussions"
  },
  "discussions_index_6c36ced": {
    "message": "Index des discussions"
  },
  "disjoint_union_e74351a8": {
    "message": "Union disjointe"
  },
  "display_options_315aba85": {
    "message": "Options d''affichage"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Afficher le lien texte (s’ouvre dans un nouvel onglet)"
  },
  "div_applied_49ad83fc": {
    "message": "Div appliquée"
  },
  "div_removed_d13f8e17": {
    "message": "Div supprimée"
  },
  "division_sign_72190870": {
    "message": "Signe de division"
  },
  "document_678cd7bf": {
    "message": "Document"
  },
  "documents_81393201": {
    "message": "Documents"
  },
  "done_54e3d4b6": {
    "message": "Terminé"
  },
  "double_dagger_faf78681": {
    "message": "Double poignard"
  },
  "down_5831a426": {
    "message": "Bas"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Flèche diagonale vers le bas et vers la gauche"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Flèche diagonale vers le bas et vers la droite"
  },
  "download_filename_2baae924": {
    "message": "Télécharger { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Flèche vers le bas"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Triangle pointant vers le bas"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Déposer un fichier ici"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Glisser et déposer ou cliquer pour naviguer sur l’ordinateur"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Poignée de déplacement. Utilisez les flèches haut et bas pour redimensionner"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Échéance : Plusieurs dates"
  },
  "due_when_7eed10c6": {
    "message": "Échéance : { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Modifier le texte alt pour cette instance d''icône"
  },
  "edit_c5fbea07": {
    "message": "Modifier"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Modifier le lien du cours"
  },
  "edit_equation_f5279959": {
    "message": "Modifier l’équation"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Modifier l’icône Maker Icon existante"
  },
  "edit_icon_2c6b0e91": {
    "message": "Modifier l’icône"
  },
  "edit_link_7f53bebb": {
    "message": "Modifier le lien"
  },
  "editor_status_bar_653f44ee": {
    "message": "Barre d’état de l’éditeur"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Élément commençant par { start }"
  },
  "embed_828fac4a": {
    "message": "Intégrer"
  },
  "embed_code_314f1bd5": {
    "message": "Intégrer le code"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Incorporer le contenu depuis l’outil externe"
  },
  "embed_image_1080badc": {
    "message": "Incorporer l’image"
  },
  "embed_video_a97a64af": {
    "message": "Intégrer la vidéo"
  },
  "embedded_content_aaeb4d3d": {
    "message": "contenu incorporé"
  },
  "empty_set_91a92df4": {
    "message": "Ensemble vide"
  },
  "encircled_dot_8f5e51c": {
    "message": "Point encerclé"
  },
  "encircled_minus_72745096": {
    "message": "Moins encerclé"
  },
  "encircled_plus_36d8d104": {
    "message": "Plus encerclé"
  },
  "encircled_times_5700096d": {
    "message": "Temps encerclés"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Icône Ingénierie"
  },
  "english_icon_25bfe845": {
    "message": "Icône Anglais"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Saisissez un titre de support"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Saisir au moins 3 caractères à rechercher"
  },
  "enter_replacement_text_17631bbc": {
    "message": "saisir le texte de remplacement"
  },
  "enter_search_text_26cb4459": {
    "message": "Saisir le texte de la recherche"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (Variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Signe égal"
  },
  "equation_1c5ac93c": {
    "message": "Équation"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editeur d''équation"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilibrium"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Classe d''équivalence"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Equivalent (Identité)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Existe"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Sortie de plein écran"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Développer l’aperçu par défaut"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Agrandir pour voir { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Lien externe"
  },
  "external_tool_frame_70b32473": {
    "message": "Cadre d’outil externe"
  },
  "external_tools_6e77821": {
    "message": "Outils externes"
  },
  "extra_large_b6cdf1ff": {
    "message": "Très grande"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Très grand ({ width } x { height }px)"
  },
  "extra_small_9ae33252": {
    "message": "Très petit"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Icône Parascolaire"
  },
  "f_function_fe422d65": {
    "message": "F (fonction)"
  },
  "fail_544e5dde": {
    "message": "ÉCHEC"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Échec de la récupération du contenu du fichier"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Impossible de récupérer le contenu de l’outil externe"
  },
  "file_name_8fd421ff": {
    "message": "Nom du fichier"
  },
  "file_preview_21667a6e": {
    "message": "Aperçu du fichier"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Aperçu du fichier pour { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Quota de stockage du fichier dépassé"
  },
  "file_url_c12b64be": {
    "message": "URL du fichier"
  },
  "filename_file_icon_602eb5de": {
    "message": "Icône de fichier de { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Aperçu de l''image de { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Aperçu du texte de { filename }"
  },
  "files_c300e900": {
    "message": "Fichiers"
  },
  "files_index_af7c662b": {
    "message": "Index des fichiers"
  },
  "find_8d605019": {
    "message": "Rechercher"
  },
  "find_and_replace_6e345933": {
    "message": "Rechercher et remplacer"
  },
  "finish_bc343002": {
    "message": "Terminer"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Corriger la hiérarchie d’entête"
  },
  "flat_music_76d5a5c3": {
    "message": "Bémol (Musique)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Barre d''outils des options d''élément de focalisation"
  },
  "folder_tree_fbab0726": {
    "message": "Arborescence de dossier"
  },
  "for_all_b919f972": {
    "message": "Pour tous"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Formater comme une liste"
  },
  "formatting_5b143aa8": {
    "message": "Formatage"
  },
  "forward_slash_3f90f35e": {
    "message": "Barre oblique"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Contenu enregistré automatiquement trouvé"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Trouvé { count, plural,\n     =0 {# résultats}\n    one {# résultat}\n  other {# résultats}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fraction"
  },
  "fullscreen_873bf53f": {
    "message": "Plein écran"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Création de l''aperçu en cours..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Les images au format GIF/PNG d’une taille supérieure à { size } Ko ne sont pas prises en charge actuellement."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Aller à la barre des menus de l’éditeur"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Aller à la barre d’outils de l’éditeur"
  },
  "grades_a61eba0a": {
    "message": "Notes"
  },
  "graphics_text_bc9568bc": {
    "message": "Texte des graphiques"
  },
  "greater_than_e98af662": {
    "message": "Supérieur à"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Supérieur ou égal"
  },
  "greek_65c5b3f7": {
    "message": "Grec"
  },
  "green_15af4778": {
    "message": "Vert"
  },
  "grey_a55dceff": {
    "message": "Gris"
  },
  "group_documents_8bfd6ae6": {
    "message": "Documents de groupe"
  },
  "group_files_4324f3df": {
    "message": "Fichiers du groupe"
  },
  "group_files_82e5dcdb": {
    "message": "Fichiers du groupe"
  },
  "group_images_98e0ac17": {
    "message": "Images de groupe"
  },
  "group_isomorphism_45b1458c": {
    "message": "Isomorphisme de groupe"
  },
  "group_link_63e626b3": {
    "message": "Lien du groupe"
  },
  "group_links_9493129e": {
    "message": "Liens de groupe"
  },
  "group_media_2f3d128a": {
    "message": "Média de Groupes"
  },
  "group_navigation_99f191a": {
    "message": "Barre de navigation des groupes"
  },
  "h_bar_bb94deae": {
    "message": "H Bar"
  },
  "hat_ea321e35": {
    "message": "Chapeau"
  },
  "header_column_f27433cb": {
    "message": "Entête de colonne"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Ligne et colonne d''entête"
  },
  "header_row_f33eb169": {
    "message": "Ligne d''entête"
  },
  "heading_2_5b84eed2": {
    "message": "En-tête 2"
  },
  "heading_3_2c83de44": {
    "message": "En-tête 3"
  },
  "heading_4_b2e74be7": {
    "message": "En-tête 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "En-tête { h } appliqué"
  },
  "heading_h_removed_745f24a6": {
    "message": "En-tête { h } supprimé"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Les niveaux d''entête ne doivent pas être ignorés."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Entête commençant par { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Les entêtes ne doivent pas contenir plus de 120 caractères."
  },
  "health_icon_8d292eb5": {
    "message": "Icône Santé"
  },
  "hearts_suit_e50e04ca": {
    "message": "Coeurs (combinaison)"
  },
  "height_69b03e15": {
    "message": "Taille"
  },
  "hexagon_d8468e0d": {
    "message": "Hexagone"
  },
  "hide_description_bfb5502e": {
    "message": "Masquer la description"
  },
  "hide_title_description_caf092ef": {
    "message": "Masquer la description de { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Mettez un élément en surbrillance pour activer la barre d''outils des options d''élément"
  },
  "home_351838cd": {
    "message": "Accueil"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Comment demander et modifier les sous-titres?"
  },
  "html_code_editor_fd967a44": {
    "message": "éditeur de code HTML"
  },
  "html_editor_fb2ab713": {
    "message": "Éditeur HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "J’ai obtenu l’autorisation d’utiliser ce fichier."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Je détiens les droits d’auteur"
  },
  "icon_215a1dc6": {
    "message": "Icône"
  },
  "icon_8168b2f8": {
    "message": "icône"
  },
  "icon_color_b86dd6d6": {
    "message": "Couleur de l’icône"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Icônes de Créateur d’icône"
  },
  "icon_options_7e32746e": {
    "message": "Options des icônes"
  },
  "icon_options_tray_2b407977": {
    "message": "Plateau des options des icônes"
  },
  "icon_preview_1782a1d9": {
    "message": "Aperçu de l’icône"
  },
  "icon_shape_30b61e7": {
    "message": "Forme de l’icône"
  },
  "icon_size_9353edea": {
    "message": "Taille de l’icône"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "S’il est laissé vide, le texte du lien s’affichera comme nom de lien de cours"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Si des droits d’utilisation sont requis, le fichier ne sera pas publié tant qu’il n’aura pas été activé dans la page Fichiers."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Si vous ne sélectionnez pas de droits d''utilisation maintenant, ce fichier ne sera pas publié après son téléversement."
  },
  "image_8ad06": {
    "message": "Image"
  },
  "image_c1c98202": {
    "message": "image"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Les fichiers d''image ne doivent pas être utilisés comme l''attribut alt décrivant le contenu de l''image."
  },
  "image_options_5412d02c": {
    "message": "Options pour l’image"
  },
  "image_options_tray_90a46006": {
    "message": "Plateau des options pour l’image"
  },
  "image_to_crop_3a34487d": {
    "message": "Image à recadrer"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Image avec nom de fichier { file }"
  },
  "images_7ce26570": {
    "message": "Images"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Les images doivent inclure un attribut alt décrivant le contenu de l''image."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Portion imaginaire (d''un nombre complexe)"
  },
  "in_element_of_19ca2f33": {
    "message": "Dans (élément de)"
  },
  "increase_indent_6af90f7c": {
    "message": "Augmenter le retrait"
  },
  "increase_rich_content_area_340b775": {
    "message": "Augmenter la zone de contenu enrichi"
  },
  "indefinite_integral_6623307e": {
    "message": "Intégrale indéfinie"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } sur { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Inférence"
  },
  "infinity_7a10f206": {
    "message": "Infinité"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Champ de saisie pour alpha"
  },
  "input_field_for_blue_561e020a": {
    "message": "Champ de saisie pour le bleu"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Champ de saisie pour le vert"
  },
  "input_field_for_red_86a84615": {
    "message": "Champ de saisie pour le rouge"
  },
  "insert_593145ef": {
    "message": "Insérer"
  },
  "insert_link_6dc23cae": {
    "message": "Insérer un lien"
  },
  "insert_math_equation_57c6e767": {
    "message": "Insérer une équation mathématique"
  },
  "integers_336344e1": {
    "message": "Nombre entier"
  },
  "intersection_cd4590e4": {
    "message": "Intersection"
  },
  "invalid_description_991e23bb": {
    "message": "Description non valide"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Saisie non valide."
  },
  "invalid_file_c11ba11": {
    "message": "Fichier non valide"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Type de fichier non valide"
  },
  "invalid_url_cbde79f": {
    "message": "URL non valide"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problème { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Italique appliqué"
  },
  "italic_removed_17cbab6f": {
    "message": "Italique supprimé"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (Variante)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Raccourcis clavier"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Les claviers naviguent vers les liens à l''aide de la touche de tabulation. Deux liens adjacents qui vous dirigent vers la même destination peuvent être source de confusion pour les utilisateurs de clavier."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Icône Arts de la langue"
  },
  "languages_icon_9d20539": {
    "message": "Icône Langues"
  },
  "large_9c5e80e7": {
    "message": "Large"
  },
  "large_text_e7ba08cd": {
    "message": "Grand texte"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Grand ({ width } x { height }px)"
  },
  "learn_ad3b3505": {
    "message": "Apprendre"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "En apprendre davantage sur les liens adjacents"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "En apprendre davantage sur les contraste des couleurs"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "En apprendre davantage sur l''organisation des en-têtes de page"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "En savoir plus sur la structure appropriée des en-têtes de page"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "En apprendre davantage sur les entêtes de tableau"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "En apprendre davantage sur l''utilisation du texte alt pour les images"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "En apprendre davantage sur l''utilisation des légendes avec des tableaux"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "En apprendre davantage sur l''utilisation de nom de fichier en tant que texte alt"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "En apprendre davantage sur les listes"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "En apprendre davantage sur l''utilisation des attributs de portée avec les tableaux"
  },
  "leave_as_is_4facfe55": {
    "message": "Laisser comme tel"
  },
  "left_3ea9d375": {
    "message": "Gauche"
  },
  "left_align_43d95491": {
    "message": "Alignement à gauche"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Support d''angle gauche"
  },
  "left_arrow_4fde1a64": {
    "message": "Flèche gauche"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Flèche gauche avec crochet"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Plafond gauche"
  },
  "left_curly_brace_1726fb4": {
    "message": "Accolade bouclée gauche"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Flèche harpon gauche vers le bas"
  },
  "left_floor_29ac2274": {
    "message": "Étage gauche"
  },
  "left_to_right_e9b4fd06": {
    "message": "Gauche-à-droite"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Flèche harpon gauche vers le haut"
  },
  "leftward_arrow_1e4765de": {
    "message": "Flèche vers la gauche"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Triangle de pointage vers la gauche"
  },
  "less_than_a26c0641": {
    "message": "Inférieur à"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Inférieur ou égal"
  },
  "library_icon_ae1e54cf": {
    "message": "Icône Bibliothèque"
  },
  "light_blue_5374f600": {
    "message": "Bleu clair"
  },
  "link_7262adec": {
    "message": "Lien"
  },
  "link_options_a16b758b": {
    "message": "Options de lien"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "Type de lien : { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Lien avec texte commençant par { start }"
  },
  "links_14b70841": {
    "message": "Liens"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Liens vers un site externe."
  },
  "lists_cd1336fc": {
    "message": "Listes"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Les listes doivent être formatées comme une liste."
  },
  "load_more_35d33c7": {
    "message": "Charger plus"
  },
  "loading_25990131": {
    "message": "En cours de chargement..."
  },
  "loading_bde52856": {
    "message": "En cours de chargement"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Le chargement des sous-titres/légendes a échoué."
  },
  "loading_external_tool_d839042c": {
    "message": "Outil externe en cours de chargement"
  },
  "loading_failed_b3524381": {
    "message": "Échec du chargement..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Échec du chargement."
  },
  "loading_folders_d8b5869e": {
    "message": "Chargement des dossiers"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Chargement de l’espace réservé pour { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Chargement en cours, veuillez patienter..."
  },
  "loading_preview_9f077aa1": {
    "message": "Chargement de l’aperçu"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Vitesse de verrouillage à 1x"
  },
  "locked_762f138b": {
    "message": "Verrouillé"
  },
  "logical_equivalence_76fca396": {
    "message": "Équivalence logique"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Équivalence logique (courte)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Equivalence logique (courte et épaisse)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Équivalence logique (épais)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Points horizontaux bas"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Cartographier à"
  },
  "math_icon_ad4e9d03": {
    "message": "Icône Mathématique"
  },
  "media_af190855": {
    "message": "Support média"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Le fichier multimédia est en cours de traitement. Veuillez essayer de nouveau plus tard."
  },
  "media_options_saved_560c4ec8": {
    "message": "Options de support média enregistrées."
  },
  "media_title_2112243b": {
    "message": "Titre du média"
  },
  "medium_5a8e9ead": {
    "message": "Moyen"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Moyen ({ width } x { height }px)"
  },
  "merge_links_2478df96": {
    "message": "Fusionner les liens"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Microphone désactivé"
  },
  "middle_27dc1d5": {
    "message": "Milieu"
  },
  "minimize_file_preview_da911944": {
    "message": "Réduire l’aperçu du fichier"
  },
  "minimize_video_20aa554b": {
    "message": "Réduire la vidéo"
  },
  "minus_fd961e2e": {
    "message": "Moins"
  },
  "minus_plus_3461f637": {
    "message": "Moins/Plus"
  },
  "misc_3b692ea7": {
    "message": "Divers"
  },
  "miscellaneous_e9818229": {
    "message": "Divers"
  },
  "module_90d9fd32": {
    "message": "Module"
  },
  "modules_c4325335": {
    "message": "Modules"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Déplacer l’image à recadrer { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Image multicolore"
  },
  "multiplication_sign_15f95c22": {
    "message": "Signe de multiplication"
  },
  "music_icon_4db5c972": {
    "message": "Icône Musique"
  },
  "my_files_2f621040": {
    "message": "Mes fichiers"
  },
  "n_th_root_9991a6e4": {
    "message": "N-ième racine"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nom"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Naturel (Musique)"
  },
  "natural_numbers_3da07060": {
    "message": "Nombres naturels"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Naviguer dans le menu ou la barre d''outils"
  },
  "navigation_ee9af92d": {
    "message": "Navigation"
  },
  "nested_greater_than_d852e60d": {
    "message": "Supérieur à (groupé)"
  },
  "nested_less_than_27d17e58": {
    "message": "Inférieur à (groupé)"
  },
  "new_quiz_34aacba6": {
    "message": "Nouveau questionnaire"
  },
  "next_40e12421": {
    "message": "Suivant"
  },
  "next_findtext_9d69f0fe": {
    "message": "{ findText } suivant"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Aucun problème d''accessibilité détecté."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Aucune annonce n’a encore été créée."
  },
  "no_announcements_found_20185afc": {
    "message": "Aucune annonce n’a été trouvée."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Aucun travail n’a encore été créé."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Aucun travail n’a été trouvé."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Aucun changement à enregister."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Aucune discussion n’a encore été créée."
  },
  "no_discussions_found_9284063b": {
    "message": "Aucune discussion n’a été trouvée."
  },
  "no_e16d9132": {
    "message": "Non"
  },
  "no_file_chosen_9a880793": {
    "message": "Aucun fichier choisi"
  },
  "no_headers_9bc7dc7f": {
    "message": "Aucun entête"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Aucun module n’a encore été créé."
  },
  "no_modules_found_2df43a40": {
    "message": "Aucun module n’a été trouvé."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Aucune page créée à ce jour."
  },
  "no_pages_found_6799350": {
    "message": "Aucune page trouvée."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Aucun aperçu n’est disponible pour ce fichier."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Aucun questionnaire n’a encore été créé."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Aucun questionnaire n’a été trouvé."
  },
  "no_results_940393cf": {
    "message": "Pas de résultats"
  },
  "no_results_found_58717065": {
    "message": "Aucun résultat trouvé"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Aucun résultat trouvé pour { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Aucune vidéo"
  },
  "none_3b5e34d2": {
    "message": "Aucun"
  },
  "none_selected_b93d56d2": {
    "message": "Aucun sélectionné"
  },
  "normal_text_7b03da48": {
    "message": "Texte normal"
  },
  "not_equal_6e2980e6": {
    "message": "Non égal"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Non dans (pas un élément de)"
  },
  "not_negation_1418ebb8": {
    "message": "Non (négation)"
  },
  "not_subset_dc2b5e84": {
    "message": "Pas de sous-ensemble"
  },
  "not_subset_strict_23d282bf": {
    "message": "Pas de sous-ensemble (Strict)"
  },
  "not_superset_5556b913": {
    "message": "Pas de sur-ensemble"
  },
  "not_superset_strict_24e06f36": {
    "message": "Pas de sur-ensemble (Strict)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Octogone"
  },
  "olive_6a3e4d6b": {
    "message": "Olive"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "L’un des styles suivants doit être ajouté pour enregistrer une icône : Couleur de l’icône, taille du contour, texte de l’icône ou image"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Un ou plusieurs fichiers n’ont pas pu être collés. Veuillez essayer de téléverser ou de glisser-déposer des fichiers."
  },
  "open_circle_e9bd069": {
    "message": "Cercle ouvert"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Ouvrir cette boîte de dialogues des raccourcis clavier"
  },
  "open_title_application_fd624fc5": {
    "message": "Ouvrir l’application { title }"
  },
  "operators_a2ef9a93": {
    "message": "Opérateurs"
  },
  "options_3ab0ea65": {
    "message": "Options"
  },
  "or_9b70ccaa": {
    "message": "Ou"
  },
  "orange_81386a62": {
    "message": "Orange"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Listes triées et non triées"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "D''autres raccourcis de l''éditeur peuvent être trouvés sur"
  },
  "outline_color_3ef2cea7": {
    "message": "Couleur du contour"
  },
  "outline_size_a6059a21": {
    "message": "Taille du contour"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } n''est pas un protocole valide."
  },
  "page_50c4823d": {
    "message": "Page"
  },
  "pages_e5414c2c": {
    "message": "Pages"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraphe"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Paragraphe appliqué"
  },
  "paragraph_removed_d09320e": {
    "message": "Paragraphe supprimé"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Paragraphe commençant par { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallèle"
  },
  "partial_derivative_4a9159df": {
    "message": "Partiel (dérivé)"
  },
  "pass_1c19a2b3": {
    "message": "RÉUSSI"
  },
  "paste_5963d1c1": {
    "message": "Coller"
  },
  "pause_12af3bb4": {
    "message": "Mettre en pause"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagone"
  },
  "people_b4ebb13c": {
    "message": "Personnes"
  },
  "percentage_34ab7c2c": {
    "message": "Pourcentage"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Le pourcentage doit être un chiffre"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Le pourcentage doit être au moins égal à { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Icône Arts de la scène"
  },
  "perpendicular_7c48ede4": {
    "message": "Perpendiculaire"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (Variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Icône Éducation physique"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (Variant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Choisissez une couleur"
  },
  "pink_68ad45cb": {
    "message": "Rose"
  },
  "pixels_52ece7d1": {
    "message": "Pixels"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Pixels doit être au moins { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Lecture"
  },
  "play_media_comment_35257210": {
    "message": "Lire le commentaire du support"
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Lire le commentaire du support par { name } du { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Disposition du lecteur"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Veuillez autoriser Canvas à accéder à votre microphone votre webcam."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Veuillez choisir un fichier"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Veuillez saisir un nom de fichier"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Veuillez saisir une URL vidéo valide provenant d’une plateforme prise en charge."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Veuillez sélectionner un fichier d’un type pris en charge"
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/Moins"
  },
  "posted_when_a578f5ab": {
    "message": "Publié : { when }"
  },
  "power_set_4f26f316": {
    "message": "Ensemble de puissance"
  },
  "precedes_196b9aef": {
    "message": "Précédant"
  },
  "precedes_equal_20701e84": {
    "message": "Précède l''égalité"
  },
  "preformatted_d0670862": {
    "message": "Préformaté"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Précédent"
  },
  "preview_53003fd2": {
    "message": "Aperçu"
  },
  "preview_a3f8f854": {
    "message": "PRÉVISUALISER"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Aperçu en superposition"
  },
  "preview_inline_9787330": {
    "message": "Aperçu « inline »"
  },
  "previous_bd2ac015": {
    "message": "Précédent"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } précédent"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Couleurs choisies précédemment"
  },
  "prime_917ea60e": {
    "message": "Premier"
  },
  "prime_numbers_13464f61": {
    "message": "Nombres premiers"
  },
  "product_39cf144f": {
    "message": "Produit"
  },
  "proportional_f02800cc": {
    "message": "Proportionnel"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Le protocole doit être ftp, http, https, mailto, skype, tel ou peut être omis"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publié"
  },
  "published_when_302d8e23": {
    "message": "Publié : { when }"
  },
  "pumpkin_904428d5": {
    "message": "Citrouille"
  },
  "purple_7678a9fc": {
    "message": "Violet"
  },
  "quaternions_877024e0": {
    "message": "Quaternions"
  },
  "quiz_e0dcce8f": {
    "message": "Questionnaire"
  },
  "quizzes_7e598f57": {
    "message": "Questionnaires"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Nombres rationnels"
  },
  "real_numbers_7c99df94": {
    "message": "Nombres réels"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Portion réelle (d''un nombre complexe)"
  },
  "record_7c9448b": {
    "message": "Enregistrer"
  },
  "record_upload_media_5fdce166": {
    "message": "Enregistrer/téléverser support média"
  },
  "recording_98da6bda": {
    "message": "Enregistrement en cours..."
  },
  "red_8258edf3": {
    "message": "Rouge"
  },
  "relationships_6602af70": {
    "message": "Relations"
  },
  "religion_icon_246e0be1": {
    "message": "Icône Religion"
  },
  "remove_f47dc62a": {
    "message": "Retirer"
  },
  "remove_filename_3ea029f6": {
    "message": "Retirer { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Retirer le style d’entête"
  },
  "remove_link_d1f2f4d0": {
    "message": "Retirer le lien"
  },
  "replace_all_d3d68b3": {
    "message": "Remplacer tout"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Remplacer tous les { findText } par des { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Remplacer"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Remplacer { findText } par { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Remplacer par"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Remplacement de { alertFindText } par { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Remplacement de tous les { alertFindText } par des { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Réinitialiser"
  },
  "resize_ec83d538": {
    "message": "Redimensionner"
  },
  "restore_auto_save_deccd84b": {
    "message": "Restaurer l''enregistrement automatique?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Résultat { index } de { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Tourniquet inversé (ne cède pas)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variante)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Éditeur de texte enrichi"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Zone de texte enrichi. Appuyez sur { OSKey }+F8 pour les raccourcis de l’éditeur de texte enrichi."
  },
  "right_71ffdc4d": {
    "message": "Droite"
  },
  "right_align_39e7a32a": {
    "message": "Alignement à droite"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Support à angle droit"
  },
  "right_arrow_35e0eddf": {
    "message": "Flèche droite"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Flèche droite avec crochet"
  },
  "right_ceiling_839dc744": {
    "message": "Plafond droit"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Accolade bouclée droite"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Flèche harpon droite descendante"
  },
  "right_floor_5392d5cf": {
    "message": "Étage droit"
  },
  "right_to_left_9cfb092a": {
    "message": "Droite-à-gauche"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Flèche harpon ascendante droite"
  },
  "rightward_arrow_32932107": {
    "message": "Flèche vers la droite"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Triangle pointant vers la droite"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Faire pivoter l''image de -90 degrés"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Faire pivoter l''image de 90 degrés"
  },
  "rotation_9699c538": {
    "message": "Rotation"
  },
  "row_fc0944a7": {
    "message": "Ligne"
  },
  "row_group_979f5528": {
    "message": "Groupe de ligne"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Malheureusement, l’éditeur Pretty HTML n’est pas accessible au clavier. Accédez à l’éditeur HTML brut ici."
  },
  "save_11a80ec3": {
    "message": "Enregistrer"
  },
  "save_copy_ca63944e": {
    "message": "Enregistrer la copie"
  },
  "save_media_cb9e786e": {
    "message": "Enregistrer le média"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Icônes enregistrées de Créateur d’icône"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Les lecteurs d''écran ne peuvent pas déterminer ce qui est affiché dans une image sans texte alternatif, et les noms de fichiers sont souvent des chaînes de chiffres et de lettres dénuées de sens qui ne décrivent pas le contexte ou le sens."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Les lecteurs d''écran ne peuvent pas déterminer ce qui est affiché dans une image sans texte alternatif, qui décrit le contenu et la signification de l''image. Le texte alternatif devrait être simple et concis."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Les lecteurs d''écran ne peuvent pas déterminer ce qui est affiché dans une image sans texte alternatif, qui décrit le contenu et la signification de l''image."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Les lecteurs d''écran ne peuvent pas interpréter les tableaux sans la structure appropriée. Les entêtes de tableau fournissent une orientation et portée du contenu."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Les lecteurs d''écran ne peuvent pas interpréter les tableaux sans la structure appropriée. Les légendes de tableau décrivent le contexte et la compréhension générale du tableau."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Les lecteurs d''écran ne peuvent pas interpréter les tableaux sans la structure appropriée. Les entêtes de tableau fournissent une orientation et l’aperçu du contenu."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "Rechercher"
  },
  "select_audio_source_21043cd5": {
    "message": "Sélectionner une source audio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Sélectionner la forme du recadrage"
  },
  "select_language_7c93a900": {
    "message": "sélectionnez la langue"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Sélectionner une source vidéo"
  },
  "selected_274ce24f": {
    "message": "Sélectionné"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } sélectionné"
  },
  "selection_b52c4c5e": {
    "message": "Sélection"
  },
  "set_header_scope_8c548f40": {
    "message": "Définir la portée de l’entête"
  },
  "set_minus_b46e9b88": {
    "message": "Ensemble moins"
  },
  "set_table_header_cfab13a0": {
    "message": "Définir l''entête du tableau"
  },
  "sharp_music_ab956814": {
    "message": "Dièse (Musique)"
  },
  "shift_arrows_4d5785fe": {
    "message": "MAJ+Flèches"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "MAJ-O pour ouvrir l’éditeur Pretty HTML."
  },
  "shortcut_911d6255": {
    "message": "Raccourci"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Afficher les options d’image"
  },
  "show_link_options_545338fd": {
    "message": "Afficher les options de lien"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Afficher la transcription en continu"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Afficher la transcription en continu"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Les utilisateurs voyants parcourent rapidement les pages Web, à la recherche d’entêtes en gros caractères ou en caractères gras. Les utilisateurs de lecteurs d''écran comptent sur les entêtes pour une compréhension contextuelle. Les entêtes devraient utiliser la structure appropriée."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Les utilisateurs voyants parcourent rapidement les pages Web, à la recherche d’entêtes en gros caractères ou en caractères gras. Les utilisateurs de lecteurs d''écran comptent sur les entêtes pour une compréhension contextuelle. Les entêtes devraient être concis au sein de la structure appropriée."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (Variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Image monochrome"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Couleur de l’image monochrome"
  },
  "size_b30e1077": {
    "message": "Taille"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "La taille du fichier de légendes est supérieure à { max } Ko, la taille maximale autorisée."
  },
  "small_b070434a": {
    "message": "Petit"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Petit ({ width } x { height }px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Cercle solide"
  },
  "something_went_wrong_89195131": {
    "message": "Une erreur est survenue."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Une erreur est survenue lors de l’accès à votre webcam."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Une erreur est survenue et je ne sais pas quoi vous montrer."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Une erreur est survenue. Vérifiez votre connexion, rechargez la page, et essayez de nouveau."
  },
  "something_went_wrong_d238c551": {
    "message": "Une erreur est survenue"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Une erreur est survenue lors du partage de votre écran."
  },
  "sort_by_e75f9e3e": {
    "message": "Trier par"
  },
  "spades_suit_b37020c2": {
    "message": "Pique (combinaison)"
  },
  "square_511eb3b3": {
    "message": "Carré"
  },
  "square_cap_9ec88646": {
    "message": "Capuchon carré"
  },
  "square_cup_b0665113": {
    "message": "Tasse carrée"
  },
  "square_root_e8bcbc60": {
    "message": "Racine carrée"
  },
  "square_root_symbol_d0898a53": {
    "message": "Symbole de la racine carrée"
  },
  "square_subset_17be67cb": {
    "message": "Sous-ensemble carré"
  },
  "square_subset_strict_7044e84f": {
    "message": "Sous-ensemble carré (Strict)"
  },
  "square_superset_3be8dae1": {
    "message": "Sur-ensemble carré"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Sur-ensemble carré (Strict)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "liste carrée non triée"
  },
  "star_8d156e09": {
    "message": "Astérisque"
  },
  "start_over_f7552aa9": {
    "message": "Recommencer"
  },
  "start_recording_9a65141a": {
    "message": "Démarrer l''enregistrement"
  },
  "steel_blue_14296f08": {
    "message": "Bleu acier"
  },
  "studio_media_options_ee504361": {
    "message": "Options média de Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Plateau des options de média Studio"
  },
  "styles_2aa721ef": {
    "message": "Styles"
  },
  "submit_a3cc6859": {
    "message": "Envoyer"
  },
  "submitting_b90fac62": {
    "message": "Envoi en cours..."
  },
  "subscript_59744f96": {
    "message": "Description"
  },
  "subset_19c1a92f": {
    "message": "Sous-ensemble"
  },
  "subset_strict_8d8948d6": {
    "message": "Sous-ensemble (Strict)"
  },
  "succeeds_9cc31be9": {
    "message": "Réussir"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Réussir l''égalité"
  },
  "sum_b0842d31": {
    "message": "Somme"
  },
  "superscript_8cb349a2": {
    "message": "Description"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Exposant et indice"
  },
  "superset_c4db8a7a": {
    "message": "Sur-ensemble"
  },
  "superset_strict_c77dd6d2": {
    "message": "Sur-ensemble (Strict)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Types de fichier pris en charge : SRT ou WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Passer à l’éditeur HTML avancé"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Passer à l''éditeur HTML brut"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Basculez à l’éditeur HTML"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Basculez vers l’éditeur de texte enrichi"
  },
  "syllabus_f191f65b": {
    "message": "Plan de cours"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Système audio autorisé"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Système audio désactivé"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TABULATION/flèches"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Entête de tableau commençant par { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tableau commençant par { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Les entêtes de tableau doivent spécifier la portée."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Les tableaux devraient comporter une légende décrivant le contenu du tableau."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Les tableaux doivent inclure au moins un entête."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Bleu sarcelle"
  },
  "text_7f4593da": {
    "message": "Texte"
  },
  "text_background_color_16e61c3f": {
    "message": "Couleur d’arrière-plan du texte"
  },
  "text_color_acf75eb6": {
    "message": "Couleur de texte"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Le texte est difficile à lire sans contraste suffisant entre le texte et l''arrière-plan, en particulier pour ceux ayant une vision faible."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Un texte d''une police supérieure à 18pt (ou 14pt gras) doit afficher un rapport de contraste minimum de 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Texte (facultatif)"
  },
  "text_position_8df8c162": {
    "message": "Position du texte"
  },
  "text_size_887c2f6": {
    "message": "Taille du texte"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Un texte avec une police plus petite que 18pt (ou 14pt gras) doit afficher un rapport de contraste minimum de 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Traitement en cours de l’aperçu du document. Veuillez essayer de nouveau plus tard."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Le premier titre d''une page doit être un H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "La hauteur de la zone de contenu enrichi est réduite."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "La hauteur de la zone de contenu enrichi est augmentée."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Ce contenu appartient au domaine public"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Ce contenu est couvert par une licence Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Le matériel fait l''objet d''une exception : par exemple, l''utilisation équitable, le droit de citer ou autres en vertu des lois applicables sur le droit d''auteur."
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "L’éditeur Pretty HTML n’est pas accessible au clavier. Appuyez sur MAJ O pour ouvrir l’éditeur HTML brut."
  },
  "therefore_d860e024": {
    "message": "Par conséquent,"
  },
  "theta_ce2d2350": {
    "message": "Thêta"
  },
  "theta_variant_fff6da6f": {
    "message": "Thêta (Variante)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Flèche épaisse vers le bas"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Flèche épaisse gauche"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Flèche épaisse vers la gauche"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Flèche droite épaisse"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Flèche épaisse vers la droite"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Flèche épaisse vers le haut"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Ce document ne peut pas être affiché dans Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Cette équation ne peut pas être affichée en mode simple."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Ce image n’est pas actuellement disponible"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Cette vidéo peut afficher des publicités sur YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Bien que votre vidéo ait le bon titre dans le navigateur, nous n''avons pas réussi à la mettre à jour dans la base de données."
  },
  "thumbnail_e0de666f": {
    "message": "Vignette"
  },
  "timebar_a4d18443": {
    "message": "Barre de temps"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "Le titre ne peut pas être vide."
  },
  "title_ee03d132": {
    "message": "Titre"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "À être publié : { when }"
  },
  "to_do_when_2783d78f": {
    "message": "À faire : { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Basculer le groupe { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Basculer l’infobulle"
  },
  "tools_2fcf772e": {
    "message": "Outils"
  },
  "top_66e0adb6": {
    "message": "Supérieur"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "Le panneau de transcription est disponible pour des largeurs supérieures à 720 px."
  },
  "tray_839df38a": {
    "message": "Plateau"
  },
  "triangle_6072304e": {
    "message": "Triangle"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Tourniquet (céder)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "saisir Control F9 pour accéder aux options d''image. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "saisir Control F9 pour accéder aux options de lien. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "saisir Control F9 pour accéder aux options de la table. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Impossible de déterminer l’URL de sélection des ressources"
  },
  "underline_applied_ae01ec97": {
    "message": "Soulignement appliqué"
  },
  "underline_removed_3693e17c": {
    "message": "Soulignement supprimé"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "non publié"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "Toute modification non enregistrée sera perdue."
  },
  "untitled_16aa4f2b": {
    "message": "Sans titre"
  },
  "untitled_efdc2d7d": {
    "message": "sans titre"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Flèche diagonale haut et gauche"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Flèche diagonale vers le haut et vers la droite"
  },
  "up_c553575d": {
    "message": "Haut"
  },
  "updated_link_a827e441": {
    "message": "Lien actualisé"
  },
  "upload_document_253f0478": {
    "message": "Téléverser le document"
  },
  "upload_file_fd2361b8": {
    "message": "Téléverser le fichier"
  },
  "upload_image_6120b609": {
    "message": "Téléverser une image"
  },
  "upload_media_ce31135a": {
    "message": "Téléverser un fichier multimédia"
  },
  "upload_record_media_e4207d72": {
    "message": "Téléverser/enregistrer un support média"
  },
  "uploading_19e8a4e7": {
    "message": "Téléversement"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "liste alphabétique en majuscules"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta majuscule"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gamma majuscule"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda majuscule"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Omega majuscule"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi en majuscule"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi majuscule"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi majuscule"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "liste triée par chiffres romains en majuscules"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma majuscule"
  },
  "uppercase_theta_49afc891": {
    "message": "Thêta majuscule"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon majuscule"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi majuscule"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Flèche pointant vers le haut et vers le bas"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Flèche pointant vers le haut et vers le bas (épaisse)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Flèche vers le haut"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Triangle pointant vers le haut"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Droit d’utilisation :"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Droits d''utilisation (requis)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Utiliser les touches directionnelles pour naviguer entre les options."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Utiliser les touches directionnelles pour sélectionner une forme."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Utiliser les touches directionnelles pour sélectionner une taille."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Utiliser les touches directionnelles pour sélectionner une position du texte."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Utiliser les touches directionnelles pour sélectionner une taille de texte."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Utiliser les touches directionnelles pour sélectionner le contour."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Utilisé par les lecteurs d''écran pour décrire le contenu d''un { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Utilisé par les lecteurs d''écran pour décrire le contenu d''une image"
  },
  "user_documents_c206e61f": {
    "message": "Documents d''utilisateur"
  },
  "user_files_78e21703": {
    "message": "Fichiers utilisateur"
  },
  "user_images_b6490852": {
    "message": "Images d'' utilisateurs"
  },
  "user_media_14fbf656": {
    "message": "Support média de l’utilisateur"
  },
  "vector_notation_cf6086ab": {
    "message": "Vecteur (notation)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Barre verticale (Notation du constructeur d''ensembles)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Points verticaux"
  },
  "video_options_24ef6e5d": {
    "message": "Options vidéo"
  },
  "video_options_tray_3b9809a5": {
    "message": "Plateau des options vidéo"
  },
  "video_player_b371005": {
    "message": "Lecteur vidéo"
  },
  "video_player_for_9e7d373b": {
    "message": "Lecteur vidéo pour "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Lecteur vidéo pour { title }"
  },
  "video_url_889d3263": {
    "message": "URL de la vidéo"
  },
  "view_all_e13bf0a6": {
    "message": "Tout afficher"
  },
  "view_ba339f93": {
    "message": "Voir"
  },
  "view_description_30446afc": {
    "message": "Visualiser la description"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Voir les raccourcis clavier"
  },
  "view_title_description_67940918": {
    "message": "Visualiser la description de { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Afficher le nombre de mots et de caractères"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Restrictions concernant l’observateur"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Nous n''avons pu détecter un microphone connecté à votre appareil."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Nous n''avons pu détecter une webcam connectée à votre appareil."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Nous n''avons pu détecter une webcam ou un microphone connecté à votre appareil."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam désactivée"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Les pages Web ne doivent avoir qu''un seul H1, qui est automatiquement utilisé par le titre de la page. Le premier titre de votre contenu doit être un H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Lorsque le langage de balisage est utilisé pour formater visuellement les éléments sous forme de liste, mais n''indique pas la relation de la liste, les utilisateurs peuvent avoir de la difficulté à naviguer dans l''information."
  },
  "white_87fa64fd": {
    "message": "Blanc"
  },
  "why_523b3d8c": {
    "message": "Pourquoi"
  },
  "width_492fec76": {
    "message": "Largeur"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "La largeur et la hauteur doivent être des nombres"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Page d’accueil de Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Décompte de mots"
  },
  "words_b448b7d5": {
    "message": "Mots"
  },
  "wreath_product_200b38ef": {
    "message": "Produit de couronne"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Oui"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Vous êtes sur une palette de couleurs. Pour naviguer dans la palette vers le haut, la gauche, le bas ou la droite, utiliser respectivement les boutons W,A, S et D"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Vous êtes sur un curseur de couleur. Pour naviguer le curseur vers la gauche ou la droite, utilisez respectivement les boutons A et D"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Vous êtes sur un curseur alpha. Pour naviguer le curseur vers la gauche ou la droite, utilisez respectivement les boutons A et D"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Vous avez des modifications non enregistrées dans le plateau d’Icon Maker. Voulez-vous continuer sans enregistrer ces changements?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Vous devrez peut-être ajuster des en-têtes supplémentaires pour maintenir la hiérarchie des pages."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Vous ne pouvez pas téléverser un fichier vide."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Votre image a été compressée pour Icon Maker. Les images inférieures à { size } Ko ne seront pas compressées."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Votre microphone est bloqué dans les paramètres du navigateur."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Votre webcam et votre microphone sont bloqués dans les paramètres du navigateur."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Votre webcam est bloquée dans les paramètres du navigateur."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Votre webcam est peut-être en cours d''utilisation."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL d’intégration dans YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zoom sur l’image"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zoom arrière sur l’image"
  }
};
formatMessage.addLocale({
  'fr-CA': locale
});